// extracted by mini-css-extract-plugin
export default {"roadmap":"Roadmap_roadmap__EaHSy","mainTitle":"Roadmap_mainTitle__BKP1e","desc":"Roadmap_desc__4beI7","smallTitle":"Roadmap_smallTitle__YpcvC","banner":"Roadmap_banner__iG3BH"};